import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCategoryPartnerInformation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.24316 6.53125C5.92253 6.53086 6.57499 6.78392 7.05566 7.23438L7.62891 7.7373L8.20703 7.23242C8.56567 6.89759 9.02216 6.66986 9.51855 6.57812C10.0151 6.48642 10.5298 6.53446 10.9971 6.7168C11.4642 6.89908 11.8628 7.20768 12.1436 7.60254C12.4242 7.9975 12.5744 8.46182 12.5742 8.93652C12.575 9.25212 12.5087 9.56491 12.3799 9.85645C12.2511 10.148 12.0618 10.4123 11.8232 10.6348L7.88086 14.3896C7.84807 14.4208 7.80868 14.445 7.76562 14.4619C7.72242 14.4789 7.67575 14.4883 7.62891 14.4883C7.58223 14.4882 7.53622 14.4788 7.49316 14.4619C7.45012 14.445 7.41072 14.4208 7.37793 14.3896L3.43457 10.6348C2.95426 10.1844 2.68411 9.57363 2.68359 8.93652C2.68318 8.29914 2.9526 7.68733 3.43262 7.23633C3.91261 6.78541 4.56395 6.53174 5.24316 6.53125ZM5 2C6.10457 2 7 2.89543 7 4C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4C3 2.89543 3.89543 2 5 2ZM10 2C11.1046 2 12 2.89543 12 4C12 5.10457 11.1046 6 10 6C8.89543 6 8 5.10457 8 4C8 2.89543 8.89543 2 10 2Z",
		fill: "current"
	})
});
export default SvgCategoryPartnerInformation;
